import React from 'react';
import { Tooltip } from 'primereact/tooltip';

const GlobalTooltip = () => {
    return <Tooltip target=".tp"
        position="right" 
        autoHide={true} 
        mouseTrack={true} 
        mouseTrackTop={15}
    />;
};

export default GlobalTooltip;